import { combineReducers } from 'redux';
import filterPanel from './filterPanelInnerReducer';
import { TASKS } from '../insertTask/insertTaskActionTypes';
import { WORKLIST } from '../worklist/worklistActionTypes';

const filterPanelReducer = combineReducers({
  tasks: filterPanel(TASKS),
  worklist: filterPanel(WORKLIST)
});

export default filterPanelReducer;
